<div [formGroup]="selectedProduct">
  <app-panel formControlName="itemSelected" [products]="products" (selected)="selected($event)"></app-panel>
</div>
<app-footer></app-footer>
